export enum SiteMapPage {
    home = '/',
    editUser = '/admin/users/user/edit',
    listUsers = '/admin/users/list',
    viewReturnOrder = '/returns/return-orders/return-order/view',
    updateDraftReturnOrder = '/returns/return-orders/return-order/update',
    pageNotFound = '/errors/page-not-found',
    changePassword = '/account/change-password',
    resetPassword = '/account/reset-password',
    signIn = '/account/sign-in',
    signOut = '/account/sign-out',
    selectReseller = '/account/select-reseller',
    listReturnOrders = '/returns/return-orders/list',
    createReturnOrder = '/returns/return-orders/create',
    confirmReturnOrder = '/returns/return-orders/confirm',
    uploadReturnOrder = '/returns/return-orders/upload',
    uploadClaim = '/claims/claims/upload',
    viewClaims = '/claims/claims/view',
    viewClaim = '/claims/claims/claim/view',
    viewCertificates = '/certificates/certificates/view',
    uploadCertificate = '/certificates/certificates/upload',
    changeReseller = '/account/change-reseller',
    listNotifications = '/notifications/notifications/list',
    termsAndConditions = '/account/accept-termsAndConditions',
    listContacts = '/reseller/contacts/list',
    editContact = '/reseller/contacts/contact/edit',
    newsPage = '/news',
    enterTrackingInfo = '/returns/enter-tracking-info',
    helpPage = '/help/help/view',
    viewPurchaseOrder = '/po-status/purchase-orders/purchase-order/view',
    listPurchaseOrders = '/po-status/purchase-orders/list',
    uploadPurchaseOrder = '/po-status/purchase-orders/upload',
    listExtractions = '/po-status/extractions/list',
    reviewPurchaseOrderExtraction = '/po-status/extractions/extraction/review',
    resellerClaimRegex = '/claims/reseller-regex/view',
}
